module.exports = __webpack_public_path__ + "img/直播banner03.dc88e3e9.png";